import { render } from "./IconRoundaboutLeft.vue?vue&type=template&id=3b45f0c2"
import script from "./IconRoundaboutLeft.vue?vue&type=script&lang=js"
export * from "./IconRoundaboutLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__